import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-lg" }
const _hoisted_2 = { class: "navbar-collapse collapse show" }
const _hoisted_3 = { class: "navbar-nav ms-auto mb-2 mb-lg-0 align-items-center" }
const _hoisted_4 = { class: "nav-item" }
const _hoisted_5 = { class: "nav-item" }
const _hoisted_6 = { class: "nav-item" }

import { reactive } from 'vue';
import DesktopMegaMenuItem from './DesktopMegaMenuItem.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'DesktopNavbar',
  props: {
  isScrolled: Boolean,
  groupedServices: Object,
  specialistServices: Array,
},
  emits: ['homeScroll'],
  setup(__props) {

const props = __props;



const state = reactive({
  activeMenuId: null as string | null,
});

let hideTimeout: number;

const showMegaMenu = (menuId: string) => {
  clearTimeout(hideTimeout);
  state.activeMenuId = menuId;
};

const hideMegaMenu = () => {
  hideTimeout = window.setTimeout(() => {
    state.activeMenuId = null;
  }, 100);
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass(["navbar navbar-expand-lg navbar-sticky sticky py-3", { 'scrolled': props.isScrolled }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        class: "navbar-brand logo-style",
        to: "/",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('homeScroll')))
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createElementVNode("span", { class: "text-primary" }, "/", -1),
          _createElementVNode("span", { class: "text-secondary" }, "/", -1),
          _createElementVNode("span", { class: "text-tertiary" }, "/", -1),
          _createTextVNode(" nologo studios ", -1)
        ]))]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("ul", _hoisted_3, [
          _createVNode(DesktopMegaMenuItem, {
            title: "What we do",
            "menu-id": "whatWeDo",
            type: "grouped",
            services: props.groupedServices,
            "view-all-link": "/services",
            "active-menu-id": state.activeMenuId,
            onShowMenu: showMegaMenu,
            onHideMenu: hideMegaMenu
          }, null, 8, ["services", "active-menu-id"]),
          _createVNode(DesktopMegaMenuItem, {
            title: "Specialist Divisions",
            "menu-id": "specialistDivisions",
            type: "simple",
            services: props.specialistServices,
            "view-all-link": "/specialist-divisions",
            "active-menu-id": state.activeMenuId,
            onShowMenu: showMegaMenu,
            onHideMenu: hideMegaMenu
          }, null, 8, ["services", "active-menu-id"]),
          _createElementVNode("li", _hoisted_4, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/about-us"
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("About", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_5, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/careers"
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode("Careers", -1)
              ]))]),
              _: 1
            })
          ]),
          _cache[5] || (_cache[5] = _createStaticVNode("<li class=\"nav-item flex justify-content-center px-1 px-md-4 py-2 text-center\" data-v-2fabf8c8><a href=\"tel:+27312660245\" class=\"text-primary pe-4\" data-v-2fabf8c8><i class=\"fas fa-phone-alt w-5 h-5\" data-v-2fabf8c8></i></a><a href=\"mailto:info@nologostudios.com\" class=\"text-primary\" data-v-2fabf8c8><i class=\"fas fa-envelope w-5 h-5 mr-2\" data-v-2fabf8c8></i></a></li>", 1)),
          _createElementVNode("li", _hoisted_6, [
            _createVNode(_component_router_link, {
              to: "/contact",
              class: "btn btn-primary text-white text-center py-2 px-4"
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode(" Get in touch ", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ], 2))
}
}

})